import { IconWarningRounded } from "@aksara-ui/icons";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogProps,
  Text,
} from "@aksara-ui/react";
import Loading from "components/Loading";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser, setModalConfirmationOpen } from "redux/actions";
import KTPVerifiedConfirmationModal from "./KTPVerifiedConfirmationModal";
interface Props {
  userId: string;
  catalogId?: string | undefined;
}

const KTPVerifiedContent: React.FC<Props & DialogProps> = ({
  isOpen,
  onClose,
  userId,
  catalogId,
}) => {
  const dispatch = useDispatch();
  const { appUrl, isLoadingModal, isModalConfirmationOpen } = useSelector(
    (state: any) => state.globalReducer
  );
  const { user } = useSelector((state: any) => state.userReducer);

  const handleCloseModal = () => {
    onClose && onClose();
  };

  const handleOpenConfirmModal = () => {
    dispatch(setModalConfirmationOpen(true) as any);
  };

  const handleCloseConfirmModal = () => {
    dispatch(setModalConfirmationOpen(false) as any);
  };

  useEffect(() => {
    if (isOpen) {
      dispatch(getUser(userId) as any);
    }
  }, [isOpen]);

  return (
    <Dialog
      disableOverlayClick
      isOpen={isOpen}
      onClose={() => handleCloseModal()}
      overflowY={"auto"}
      maxHeight={"90vh"}
      width={750}
      maxWidth={"95vw"}
      style={{
        height: "75vh",
        display: "flex",
        alignContent: "center",
      }}
    >
      <DialogHeader>
        <Text fontWeight={700}>KTP Verified</Text>
      </DialogHeader>
      <DialogContent>
        {isLoadingModal ? (
          <Loading />
        ) : (
          <Box>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
              height="50vh"
              padding="16px"
              backgroundColor="#e0e0e0"
              borderRadius="8px"
              marginBottom="24px"
            >
              {user.ktp_photo ? (
                <img
                  src={`${appUrl}/storage/${user.ktp_photo}`}
                  alt="User uploaded"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                <Text fontSize={16} color="#555">
                  Foto KTP tidak ditemukan.
                </Text>
              )}
            </Box>
            {!user.is_ktp_verified ? (
              <Box display="flex" justifyContent="center" alignItems="center">
                <Button
                  onClick={() => handleOpenConfirmModal()}
                  variant={"primary"}
                  icon={IconWarningRounded}
                  iconPosition={"left"}
                  style={{
                    borderRadius: "6px",
                  }}
                  disabled={!user.ktp_photo}
                >
                  Verifikasi KTP
                </Button>
              </Box>
            ) : (
              <></>
            )}
          </Box>
        )}

        <KTPVerifiedConfirmationModal
          catalogId={catalogId}
          userId={userId}
          isOpen={isModalConfirmationOpen}
          onClose={() => handleCloseConfirmModal()}
        />
      </DialogContent>
    </Dialog>
  );
};

export default KTPVerifiedContent;
